import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { getUserIdFromToken } from '~/utils/helper';

export interface IGmailIntegration {
  id: number;
  userId: number;
  provider: string;
  emailAddress: string;
  status: 'connected' | 'revoked';
  connectedAt: string;
}

export interface IEmailAttachment {
  filename: string;
  content: string; // base64 encoded
  mimeType: string;
}

export interface ISendEmailPayload {
  to: string;
  subject: string;
  body: string;
  attachments?: IEmailAttachment[];
  inReplyTo?: string;
  references?: string;
  jobId?: string;
}

export interface ISendEmailResponse {
  id: string;
  threadId: string;
  labelIds: string[];
}

export interface IEmailMessage {
  id: string;
  threadId: string;
  from?: string;
  to?: string;
  subject?: string;
  date?: string;
  snippet?: string;
  labelIds?: string[];
}

export interface IListMessagesResponse {
  messages: IEmailMessage[];
  resultSizeEstimate: number;
}

export interface IEmailHeader {
  name: string;
  value: string;
}

export interface IEmailBody {
  data?: string;
  attachmentId?: string;
  size?: number;
}

export interface IEmailPayload {
  headers: IEmailHeader[];
  body: IEmailBody;
  parts?: IEmailPayload[];
}

export interface IEmailDetail {
  id: string;
  threadId: string;
  labelIds: string[];
  snippet: string;
  payload: IEmailPayload;
}

const gmailIntegrationApi = {
  // GET /api/integrations/google/gmail?userId=X
  getIntegrations() {
    const userId = getUserIdFromToken();
    const url = `/api/integrations/google/gmail${userId ? `?userId=${userId}` : ''}`;
    return axiosClient.get<IApiBaseResponse<IGmailIntegration[]>>(url);
  },
  // DELETE /api/integrations/google/gmail?userId=X
  disconnectGmail() {
    const userId = getUserIdFromToken();
    const url = `/api/integrations/google/gmail${userId ? `?userId=${userId}` : ''}`;
    return axiosClient.delete<IApiBaseResponse<null>>(url);
  },
  // POST /api/integrations/google/gmail/send
  sendEmail(payload: ISendEmailPayload) {
    const url = `/api/integrations/google/gmail/send`;
    return axiosClient.post<IApiBaseResponse<ISendEmailResponse>>(url, payload);
  },
  // GET /api/integrations/google/gmail/messages
  listMessages(params?: { maxResults?: number; from?: string; q?: string }) {
    const url = `/api/integrations/google/gmail/messages`;
    return axiosClient.get<IApiBaseResponse<IListMessagesResponse>>(url, { params });
  },
  // GET /api/integrations/google/gmail/messages/:id
  getMessageDetail(messageId: string) {
    const url = `/api/integrations/google/gmail/messages/${messageId}`;
    return axiosClient.get<IApiBaseResponse<IEmailDetail>>(url);
  },
};

export default gmailIntegrationApi;

